import React from 'react'
import {MenuItem} from '@mui/material'
import {useSelector} from 'react-redux'
import {selectObjectivesList} from '../../../../redux/flashcard'
import {v4 as uuidv4} from 'uuid'
import {capitalizeFirstChar} from '../../../../utils/capitalizeFirstLetter'
import {CardNumber} from '../../../../pages/FlashCards/view'
import {FilterBox, RightFilter, StyledInput, StyledSelect} from './styles'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

type Props = {
  dropDownSelection: string
  setDropDownSelection: (value: string) => void
  filterBySelection: string
  setFilterBySelection: (value: string) => void
  setSearchInput: (value: string) => void
  cardNumbers: CardNumber
  searchInput: string
  setFlashCardNumber: (value: number) => void
}

const View = ({
  dropDownSelection,
  setDropDownSelection,
  filterBySelection,
  setFilterBySelection,
  setSearchInput,
  cardNumbers,
  searchInput,
  setFlashCardNumber,
}: Props) => {
  const dropDownOptions = useSelector(selectObjectivesList)

  const handleChange = (event: any) => {
    setFlashCardNumber(1)
    setDropDownSelection(event.target.value)
  }

  const handleChangeFilter = (event: any) => {
    setFlashCardNumber(1)
    setFilterBySelection(event.target.value)
  }

  return (
    <FilterBox>
      <StyledSelect
        value={dropDownSelection}
        onChange={handleChange}
        IconComponent={KeyboardArrowDownIcon}
      >
        {dropDownOptions
          ? Object.keys(dropDownOptions)
              .sort((a, b) => {
                const aIsNumber = !isNaN(Number(a))
                const bIsNumber = !isNaN(Number(b))

                if (aIsNumber && bIsNumber) {
                  return Number(a) - Number(b)
                } else if (!aIsNumber && !bIsNumber) {
                  return a.localeCompare(b)
                } else {
                  return aIsNumber ? 1 : -1
                }
              })
              .map((objectKey: string) => {
                const objectiveStart = !['all', 'custom', 'default'].includes(
                  objectKey,
                )
                  ? 'Objective '
                  : ''

                return (
                  <MenuItem value={objectKey} key={uuidv4()}>
                    {`${objectiveStart} ${capitalizeFirstChar(objectKey)} (${
                      dropDownOptions[objectKey as any]
                    })`}
                  </MenuItem>
                )
              })
          : null}
      </StyledSelect>

      <RightFilter>
        <StyledInput
          name={'searchInput'}
          placeholder={'Ex: Information'}
          type={'text'}
          value={searchInput}
          onChange={e => {
            setSearchInput(e.target.value)
            setFlashCardNumber(1)
          }}
        />

        <StyledSelect
          value={filterBySelection}
          onChange={handleChangeFilter}
          IconComponent={KeyboardArrowDownIcon}
        >
          <MenuItem value={'All'}>All Cards ({cardNumbers.all})</MenuItem>
          <MenuItem value={'Mastered'}>
            Mastered ({cardNumbers.mastered})
          </MenuItem>
          <MenuItem value={'Unmastered'}>
            Unmastered ({cardNumbers.unmastered})
          </MenuItem>
        </StyledSelect>
      </RightFilter>
    </FilterBox>
  )
}

export default View
